var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglePlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 270,
    height: 78,
    viewBox: "0 0 270 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M260 1.56244C264.63 1.56244 268.397 5.23575 268.397 9.75V68.25C268.397 72.7642 264.63 76.4376 260 76.4376H10C5.37 76.4376 1.6025 72.7642 1.6025 68.25V9.75C1.6025 5.23575 5.37 1.56244 10 1.56244H260ZM260 2.86102e-06H10C4.5025 2.86102e-06 0 4.38994 0 9.75V68.25C0 73.6101 4.5025 78 10 78H260C265.497 78 270 73.6101 270 68.25V9.75C270 4.38994 265.497 2.86102e-06 260 2.86102e-06Z",
    fill: "#0B2878"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.87 14.7007C20.2825 15.3003 19.9425 16.2339 19.9425 17.4429V60.5671C19.9425 61.7761 20.2825 62.7097 20.87 63.3093L21.015 63.4409L45.8 39.2853V38.7149L21.015 14.5593L20.87 14.7007Z",
    fill: "url(#paint0_linear_13202_45561)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0524 47.3413L45.7999 39.2854V38.715L54.0624 30.6591L54.2474 30.7639L64.0324 36.1922C66.8249 37.7327 66.8249 40.2677 64.0324 41.8179L54.2474 47.2365L54.0524 47.3413Z",
    fill: "url(#paint1_linear_13202_45561)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2475 47.2363L45.8 39L20.87 63.3092C21.7975 64.2598 23.31 64.3744 25.03 63.4238L54.2475 47.2363Z",
    fill: "url(#paint2_linear_13202_45561)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2475 30.7637L25.03 14.5763C23.31 13.6354 21.7975 13.7499 20.87 14.7006L45.8 39L54.2475 30.7637Z",
    fill: "url(#paint3_linear_13202_45561)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8349 19.9753C94.8349 21.6035 94.335 22.9076 93.35 23.8802C92.2175 25.0331 90.7425 25.6132 88.935 25.6132C87.2075 25.6132 85.7324 25.0233 84.5224 23.8607C83.3099 22.6809 82.705 21.233 82.705 19.5C82.705 17.7669 83.3099 16.319 84.5224 15.149C85.7324 13.9766 87.2075 13.3867 88.935 13.3867C89.795 13.3867 90.6149 13.5598 91.3974 13.8815C92.1774 14.2057 92.8124 14.6445 93.2724 15.1856L92.2275 16.2142C91.425 15.2904 90.3325 14.8346 88.935 14.8346C87.675 14.8346 86.5825 15.2636 85.655 16.1289C84.7375 16.9967 84.2775 18.1203 84.2775 19.5C84.2775 20.8796 84.7375 22.013 85.655 22.8808C86.5825 23.7363 87.675 24.1751 88.935 24.1751C90.2725 24.1751 91.3975 23.7363 92.285 22.871C92.87 22.2982 93.2025 21.5085 93.29 20.4993H88.935V19.0905H94.745C94.815 19.3952 94.8349 19.6901 94.8349 19.9753Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M104.052 15.0905H98.5949V18.7955H103.515V20.2043H98.5949V23.9093H104.052V25.345H97.0499V13.6548H104.052V15.0905Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M110.557 25.345H109.012V15.0905H105.665V13.6548H113.907V15.0905H110.557V25.345Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M119.872 25.345V13.6548H121.415V25.345H119.872Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M128.252 25.345H126.72V15.0905H123.36V13.6548H131.612V15.0905H128.252V25.345Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M147.217 23.8412C146.035 25.0233 144.57 25.6132 142.822 25.6132C141.065 25.6132 139.6 25.0233 138.417 23.8412C137.237 22.6614 136.65 21.2135 136.65 19.5C136.65 17.7864 137.237 16.3385 138.417 15.1588C139.6 13.9766 141.065 13.3867 142.822 13.3867C144.56 13.3867 146.025 13.9766 147.207 15.1685C148.397 16.358 148.985 17.7962 148.985 19.5C148.985 21.2135 148.397 22.6614 147.217 23.8412ZM139.56 22.8613C140.45 23.7363 141.532 24.1751 142.822 24.1751C144.102 24.1751 145.195 23.7363 146.075 22.8613C146.962 21.9862 147.412 20.8625 147.412 19.5C147.412 18.1374 146.962 17.0137 146.075 16.1387C145.195 15.2636 144.102 14.8248 142.822 14.8248C141.532 14.8248 140.45 15.2636 139.56 16.1387C138.672 17.0137 138.222 18.1374 138.222 19.5C138.222 20.8625 138.672 21.9862 139.56 22.8613Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M151.152 25.345V13.6548H153.027L158.857 22.7467H158.925L158.857 20.4993V13.6548H160.4V25.345H158.79L152.685 15.8047H152.617L152.685 18.0618V25.345H151.152Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M136.27 42.4174C131.572 42.4174 127.735 45.9031 127.735 50.7122C127.735 55.4824 131.572 59.0046 136.27 59.0046C140.977 59.0046 144.815 55.4824 144.815 50.7122C144.815 45.9031 140.977 42.4174 136.27 42.4174ZM136.27 55.7384C133.692 55.7384 131.475 53.6641 131.475 50.7122C131.475 47.7214 133.692 45.6837 136.27 45.6837C138.847 45.6837 141.075 47.7214 141.075 50.7122C141.075 53.6641 138.847 55.7384 136.27 55.7384ZM117.647 42.4174C112.94 42.4174 109.113 45.9031 109.113 50.7122C109.113 55.4824 112.94 59.0046 117.647 59.0046C122.352 59.0046 126.182 55.4824 126.182 50.7122C126.182 45.9031 122.352 42.4174 117.647 42.4174ZM117.647 55.7384C115.067 55.7384 112.843 53.6641 112.843 50.7122C112.843 47.7214 115.067 45.6837 117.647 45.6837C120.225 45.6837 122.443 47.7214 122.443 50.7122C122.443 53.6641 120.225 55.7384 117.647 55.7384ZM95.4875 44.9597V48.4844H104.12C103.868 50.4539 103.193 51.9017 102.158 52.9109C100.898 54.1296 98.935 55.4824 95.4875 55.4824C90.175 55.4824 86.015 51.3021 86.015 46.1224C86.015 40.9427 90.175 36.7624 95.4875 36.7624C98.36 36.7624 100.45 37.8569 101.993 39.2755L104.54 36.7917C102.383 34.7832 99.5125 33.2402 95.4875 33.2402C88.2025 33.2402 82.08 39.0196 82.08 46.1224C82.08 53.2253 88.2025 59.0046 95.4875 59.0046C99.425 59.0046 102.383 57.7469 104.708 55.3874C107.09 53.0644 107.833 49.7982 107.833 47.1608C107.833 46.3418 107.763 45.5886 107.638 44.9597H95.4875ZM186.102 47.6922C185.4 45.8372 183.232 42.4174 178.817 42.4174C174.442 42.4174 170.8 45.7787 170.8 50.7122C170.8 55.3581 174.405 59.0046 179.237 59.0046C183.145 59.0046 185.4 56.6817 186.327 55.3289L183.427 53.4447C182.46 54.8243 181.142 55.7384 179.237 55.7384C177.345 55.7384 175.987 54.8926 175.117 53.2253L186.495 48.6355L186.102 47.6922ZM174.502 50.4539C174.405 47.2559 177.05 45.6179 178.945 45.6179C180.43 45.6179 181.69 46.3418 182.11 47.3777L174.502 50.4539ZM165.255 58.5H168.995V34.1251H165.255V58.5ZM159.13 44.2651H159.005C158.165 43.2949 156.562 42.4174 154.533 42.4174C150.272 42.4174 146.377 46.0639 146.377 50.7391C146.377 55.3874 150.272 59.0046 154.533 59.0046C156.562 59.0046 158.165 58.1198 159.005 57.1204H159.13V58.3099C159.13 61.4811 157.392 63.1849 154.59 63.1849C152.305 63.1849 150.887 61.5762 150.302 60.2234L147.05 61.5469C147.987 63.7455 150.47 66.4512 154.59 66.4512C158.975 66.4512 162.675 63.9357 162.675 57.8151V42.922H159.13V44.2651ZM154.852 55.7384C152.275 55.7384 150.117 53.6348 150.117 50.7391C150.117 47.8165 152.275 45.6837 154.852 45.6837C157.392 45.6837 159.395 47.8165 159.395 50.7391C159.395 53.6348 157.392 55.7384 154.852 55.7384ZM203.612 34.1251H194.667V58.5H198.397V49.2644H203.612C207.755 49.2644 211.817 46.3418 211.817 41.6935C211.817 37.0476 207.745 34.1251 203.612 34.1251ZM203.71 45.8738H198.397V37.5156H203.71C206.495 37.5156 208.085 39.7703 208.085 41.6935C208.085 43.5801 206.495 45.8738 203.71 45.8738ZM226.767 42.3711C224.072 42.3711 221.27 43.5314 220.117 46.1029L223.427 47.4557C224.14 46.1029 225.45 45.6642 226.835 45.6642C228.77 45.6642 230.732 46.7976 230.762 48.7988V49.0547C230.087 48.6745 228.642 48.1114 226.865 48.1114C223.3 48.1114 219.667 50.0249 219.667 53.5958C219.667 56.8621 222.587 58.9656 225.87 58.9656C228.38 58.9656 229.765 57.8614 230.635 56.5769H230.762V58.461H234.365V49.1108C234.365 44.7891 231.055 42.3711 226.767 42.3711ZM226.317 55.7286C225.097 55.7286 223.397 55.1387 223.397 53.6641C223.397 51.7774 225.517 51.0535 227.352 51.0535C228.995 51.0535 229.765 51.4069 230.762 51.8725C230.47 54.1296 228.477 55.7286 226.317 55.7286ZM247.49 42.9049L243.202 53.4715H243.075L238.642 42.9049H234.62L241.28 57.6713L237.48 65.8881H241.377L251.64 42.9049H247.49ZM213.867 58.5H217.607V34.1251H213.867V58.5Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13202_45561",
    x1: 43.5994,
    y1: 61.0162,
    x2: 10.8842,
    y2: 27.4622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13202_45561",
    x1: 67.6687,
    y1: 38.9975,
    x2: 19.2749,
    y2: 38.9975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_13202_45561",
    x1: 49.654,
    y1: 34.5226,
    x2: 5.28953,
    y2: -10.9794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_13202_45561",
    x1: 14.5946,
    y1: 77.6564,
    x2: 34.4053,
    y2: 57.3379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/GooglePlay.644a095633e648e92b99872d6996f827.svg";
export { ForwardRef as ReactComponent };